import React from "react";

const administrationRoutes = [
    {
        path: "/administrations/audit/list",
        component: React.lazy(() => {
            return import("./auditLog/AuditList");
        }),
    },
    {
        path: "/administrations/audit/:viewType/:id?",
        component: React.lazy(() => import("./auditLog/AuditFormDetail")),
    },
    {
        path: "/administrations/exception/list",
        component: React.lazy(() => {
            return import("./exception/ExceptionList");
        }),
    },
    {
        path: "/administrations/controlButton/list",
        component: React.lazy(() => {
            return import("./controlButton/ControlButtonList");
        }),
    },
    {
        path: "/administrations/exception/:viewType/:id?",
        component: React.lazy(() => import("./exception/ExceptionForm")),
    },

    {
        path: "/administrations/document/list",
        component: React.lazy(() => {
            return import("./document/DocumentList");
        }),
    },
    {
        path: "/administrations/applicationAdvancedSearch/list",
        component: React.lazy(() => {
            return import("./applicationAdvancedSearch/AdvancedSearchList");
        }),
    },
    {
        path: "/administrations/applicationCertificate/list",
        component: React.lazy(() => {
            return import("./applicationCertificate/ApplicationCertificateList");
        }),
    },
    {
        path: "/administrations/applicationCertificate/view/:id?",
        component: React.lazy(() => import("./applicationCertificate/ApplicationCertificateFormDetail")),
    },
    {
        path: "/administrations/report/list",
        component: React.lazy(() => {
            return import("./report/ReportList");
        }),
    },
    {
        path: "/administrations/report/generate/:id",
        component: React.lazy(() => import("./report/ReportGenerate")),
    },
    {
        path: "/administrations/sysparam/list",
        component: React.lazy(() => {
            return import("./sysparam/SysParamList");
        }),
    },
    {
        path: "/administrations/sysparam/:viewType/:sysKey?",
        component: React.lazy(() => import("./sysparam/SysParamForm")),
    },
];

export default administrationRoutes;
